import { createFileRoute, redirect } from "@tanstack/react-router";
import { MarketingContentPage } from "../components/marketing/MarketingContentPage";
import { contentHead, loadContentPage } from "../marketing-content/load";
import { publicRedirectPath } from "../marketing-content/legacy";

export const Route = createFileRoute("/blog_/$slug")({
  beforeLoad: ({ location }) => {
    const href = publicRedirectPath(location.pathname);
    if (href) throw redirect({ href, replace: true });
  },
  loader: ({ params }) => loadContentPage(`/blog/${params.slug}`),
  head: ({ loaderData }) => contentHead(loaderData),
  component: ContentRoute,
});
function ContentRoute() {
  return <MarketingContentPage page={Route.useLoaderData()} />;
}
